import { render } from "./dashBoard.vue?vue&type=template&id=7a9dddbd&scoped=true"
import script from "./dashBoard.vue?vue&type=script&lang=js"
export * from "./dashBoard.vue?vue&type=script&lang=js"

import "./dashBoard.vue?vue&type=style&index=0&id=7a9dddbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9dddbd"]])

export default __exports__